import { render } from "./DTSTraining.vue?vue&type=template&id=1def075a&scoped=true"
import script from "./DTSTraining.vue?vue&type=script&lang=js"
export * from "./DTSTraining.vue?vue&type=script&lang=js"

import "./DTSTraining.vue?vue&type=style&index=0&id=1def075a&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1def075a"]])

export default __exports__